var e=function(e){return Object.keys(e).reduce((function(r,n){return r[e[n]]=n,r}),{})};export{e as objectSwapKeysAndValues};
//# sourceMappingURL=objectSwapKeysAndValues.js.map
